var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61,
    height: 78,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.3598048,-4.86379019 L60.7920709,4.93247034 L44.267079,76.5062266 C44.1726143,76.9153763 43.7643542,77.1704788 43.3552045,77.0760141 C43.2849728,77.059799 43.2174036,77.0336794 43.1545261,76.9984396 L24.5840525,66.590623 L24.5840525,66.590623 L2.61099835,67.6497097 C2.19157213,67.6699258 1.83517163,67.346302 1.81495557,66.9268758 C1.81159419,66.8571367 1.81785479,66.7872671 1.83356087,66.7192366 L18.3598048,-4.86379019 L18.3598048,-4.86379019 Z",
    id: "b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6006264,3.9487137 L55.8626499,17.9563995 C56.4507594,18.2959447 56.8130499,18.9234501 56.8130499,19.6025406 L56.8130499,47.6179122 C56.8130499,48.2970026 56.4507594,48.924508 55.8626499,49.2640532 L31.6006264,63.271739 C31.0125168,63.6112843 30.2879359,63.6112843 29.6998264,63.271739 L5.43780288,49.2640532 C4.84969331,48.924508 4.48740288,48.2970026 4.48740288,47.6179122 L4.48740288,19.6025406 C4.48740288,18.9234501 4.84969331,18.2959447 5.43780288,17.9563995 L29.6998264,3.9487137 C30.2879359,3.60916848 31.0125168,3.60916848 31.6006264,3.9487137 Z",
    id: "c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8746752,0.181513453 L45.715472,12.2139531 C45.833094,12.2818622 45.905552,12.4073632 45.905552,12.5431813 L45.905552,36.6080606 C45.905552,36.7438787 45.833094,36.8693798 45.715472,36.9372889 L24.8746752,48.9697285 C24.7570533,49.0376376 24.6121371,49.0376376 24.4945152,48.9697285 L3.65371839,36.9372889 C3.53609648,36.8693798 3.46363839,36.7438787 3.46363839,36.6080606 L3.46363839,12.5431813 C3.46363839,12.4073632 3.53609648,12.2818622 3.65371839,12.2139531 L24.4945152,0.181513453 C24.6121371,0.113604409 24.7570533,0.113604409 24.8746752,0.181513453 Z",
    id: "e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.549%",
    y1: "14.657%",
    x2: "20.867%",
    y2: "84.495%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C55E8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB93FF",
    offset: "48.996%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C55E8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.997%",
    y1: "16.693%",
    x2: "24.248%",
    y2: "84.823%",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD96FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCC7FF",
    offset: "46.038%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD96FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-11.5%",
    y: "-6.1%",
    width: "123.3%",
    height: "116.5%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1 1) rotate(-13 0 310.153)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#6C36C6",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#6C36C6",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#8C55E8",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.966 9.035)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#4D1AA2",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F6F7",
    opacity: 0.054,
    mask: "url(#f)",
    d: "M-1.49760097 39.5783032L50.8474187 9.47050781 11.9397444 -12.7554289 -2.34968427 -2.08085125z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.4374023,10.3182633 L50.6693928,21.7922201 L50.8486499,45.0506162 L30.7959166,56.8350556 L10.5639261,45.3610988 L10.384669,22.1027027 L30.4374023,10.3182633 Z",
    stroke: "url(#g)",
    strokeWidth: 2.432
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 7.603,
    fontWeight: 500,
    fill: "#BD96FF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24.306,
    y: 26.883
  }, "ViP")), /*#__PURE__*/React.createElement("path", {
    fill: "#BD96FF",
    d: "M20.0766471 26.2087209L18.8336484 26.862204 19.07104 25.4781046 18.0654329 24.4978798 19.4551477 24.2959425 20.0766471 23.0366471 20.6981465 24.2959425 22.0878614 24.4978798 21.0822543 25.4781046 21.3196459 26.862204zM41.5259079 26.2087209L40.2829091 26.862204 40.5203007 25.4781046 39.5146936 24.4978798 40.9044085 24.2959425 41.5259079 23.0366471 42.1474073 24.2959425 43.5371221 24.4978798 42.531515 25.4781046 42.7689066 26.862204z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.1b226887407765456d8b19397e1f0e78.svg";
export { ForwardRef as ReactComponent };